<template>
  <section class="sec-benefit background-sec">
    <div class="sec-titr">
      <h2 class="sec-titr__title">خواص عسل طبیعی</h2>
    </div>
    <div class="container-benefit">
      <div class="benefit-title">
        <ul class="benefit-list">
          <li class="benefit-item" v-for="name in benefitNameList" :key="name">
            <img
              @click="showBenefit(name,$event)"
              class="benefit-image"
              src="../../../public/image/hexagon-mask.png"
            />
            <h3 class="benefit-item__name">{{ name }}</h3>
          </li>
        </ul>
      </div>
      <div class="benefit-describ">
        <transition name="benefit" mode="out-in">
          <div class="benefit-describ-text" v-show="enterBenefitOfHoney">
            <p>{{ benefitOfHoney }}</p>
          </div>
        </transition>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      benefitOfHoney: null,
      enterBenefitOfHoney: true,
      benefitNameList: [
        "عسل یونجه",
        "عسل چند گیاه",
        "عسل کتیرا",
        "عسل گون",
        "عسل آویشن",
        "عسل سياهدانه",
        "عسل کنار",
        "عسل مرکبات",
        "عسل گشنيز",
        "عسل زرشک",
        "عسل مریم گلی",
        " عسل وحشی",
        "عسل جعفری",
      ],
      benefitHoneyeList: [
        {
          name: "عسل یونجه",
          benefit:
            "عسل یونجه مقوی مغز و اعصاب بوده و حافظه را افزایش می دهد، بیشترین مقدار ویتامین های ۸ و ۸ را دارد و برای افرادی که خون دماغ میشوند، بسیار نافع است. این عسل بسیار خوش عطر و طعم می باشد. ملین و خون ساز است، بندآورنده خون، مفید برای اختلالات عادت ماهیانه خانم ها، برای افرادی که دچار لرزش های اندام می شوند مفید است و همچنین نشاط آور است.",
        },
        {
          name: "عسل چند گیاه",
          benefit:
            "عسل چند گیاه یا چهل گیاه حاصل نوشیدن شهد گل های مختلف توسط زنبور عسل است. عموما در فصل بهار که گیاهان مختلفی در یک منطقه می روید، زنبور شهد گل های مختلفی را به عسل تبدیل می کند. این نوع عسل خواص عمومی زیادی برای بدن داشته و برای بیماری های مختلفی توصیه شده است. ضد ورم و عفونت روده، ضد یبوست، ضد عفونی کننده دستگاه گوارش، ضد اسهال، تب بر، تقویت اعصاب، ضد سرفه و آسم، ضد سنگ کلیه و مثانه، اشتها آور، خواب آور، تصفیه خون و کبد، درمان میگرن، مبارزه با پوکی استخوان از خواص عسل چند گل است.",
        },
        {
          name: "عسل کتیرا",
          benefit:
            "عسل کتیرا که شهد غالب آن یکی از گونه های معروف گون به نام گیاه کتیرا می باشد، دارای خواص دارویی بسیاری مانند تقویت اعصاب، تقویت حافظه و تقویت معده می باشد.",
        },
        {
          name: "عسل گون",
          benefit:
            "عسل گون باعث تقویت مغز و اعصاب می شود و انرژی زا بوده که به تقویت حافظه نیز کمک می کند، برای کم خونی مفید است، خواب آور می باشد،",
        },
        {
          name: "عسل آویشن",
          benefit:
            "عسل آویشن مقوی مغز و اعصاب می باشد و یک انرژی زای قوی بوده که به تقویت حافظه کمک میکند، همچنین برای دردهای قاعدگی، دردهای شکمی و روده، تسکین سرفه و گلودرد، درمان دیابت بی مزه، عفونت های عمومی بدن و برای پانسمان زخم های بستر مفید است.",
        },
        {
          name: "عسل کنار",
          benefit:
            "عسل کنار مقوی و انرژی زا است که به تقویت حافظه و رشد کودکان کمک می کند، مسهل صفرا، حرارت بدن را فرو مینشاند، مؤثر و بازکننده گرفتگی هاست، کرم معده و روده را از بین می برد، مفید برای گرم مزاجان، برای ناراحتی ها و زخم روده و تب نافع است، برای آبله و سرخجه و عطش، همچنین سستی اعضا، تقویت مو، جلوگیری از ریزش مو، تقویت اعصاب و تحلیل ورم های گرم مؤثر و سودمند است.",
        },
        {
          name: "عسل مرکبات",
          benefit:
            "عسل مرکبات برای تقویت حافظه بینظیر است و انرژی زا می باشد، همچنین مفید برای درمان مشکلات معده، بادشکن، کمبود ویتامین C، تهوع و سم، نرم کننده سینه، سرماخوردگی، ورم های بدن، ضدعفونی کننده، تصفیه خون، اشتها آور، ناراحتیهای صفرا، مسکن، مفید برای سکسکه، کرم های روده، مفید برای سرطان های معده، ازدیاد متابولیسم پایه، پیشگیری از انواع سرطان ها، کاهش کلسترول، ضدباکتری و قارچ است.",
        },
        {
          name: "عسل گشنيز",
          benefit:
            "عسل گشنیز دارای عطر تند و طعم های خاصی است. از گل های سفید و صورتی چتردار جمع آوری می شود. شکوفه های گشنیز رشد کرده در یک هکتار زمین، حدود ۵۰۰ کیلوگرم عسل می دهد. از خواص عسل گشنیز می توان به: اشتها آوری، مقوی معده، رفع سوءهاضمه، بادشکن، نرم کننده سینه، تب بُر، مفید برای بیماریهای عفونی مانند: سرخک و آبله، برای سرفه و سرماخوردگی، مسکن و آرام بخش، دفع سموم بدن، خواب آور، مفید برای زکام و اسپاسم ماهیچه ای، شیر افزا، مفید برای تب های روماتیسمی، خواب آور، مفید برای آفت دهان، تقویت لثه، تنگی نفس، مسکن صفرا، ضد سرطان، مفرح، مقوی قلب و مغز، اسپرم، ناراحتی روده و حافظه اشاره کرد.",
        },
        {
          name: "عسل مریم گلی",
          benefit:
            "این عسل از شهد گیاه معروف مریم گلی ساخته می شود که از گیاهان دارویی پر کاربرد است. عسل مریم گلی به رنگ کهربایی روشن تا تیره زرین با بو و مزه دلپسند است. هر هکتار تحت کشت مریم گلی حدود ۶۰۰ کیلوگرم عسل می دهد. از خواص آن می توان به تصفیه خون، رفع تعریق بیش از حد بدن، کمک به سیستم گوارش، بهبود زخم ها و بریدگی ها، تحریک اشتها و بهبود سرماخوردگی اشاره کرد.",
        },
        {
          name: " عسل وحشی",
          benefit:
            "عسل وحشی از نوعی زنبور های کوچکی که با زنبور های معمولی و پرورش یافته فرق دارند به وجود می آید. این زنبور ها در بالای درختان و شکاف صخره ها در کوهستان ها اقدام به ساخت کلنی می کنند و عسل ها با سختی بسیاری از این کلنی ها برداشت می شود. به دلیل خواص درمانی فوق العاده و سختی در برداشت عسل وحشی و حتی کمیابی این نو عسل، قیمت نسبتا بالایی هم در داخل کشور دارد. از مهمترین خواص این نوع عسل می توان به انرژی زایی بالا، درمان مشکلات گوارشی، درمان کم خونی، تقویت حافظه و همچنین تقویت قوای جنسی اشاره کرد.",
        },
        {
          name: "عسل جعفری",
          benefit:
            "عسل جعفری مقوی و انرژی زا می باشد. به بهبود بی خوابی، تقویت مغز و حافظه کمک می کند. مناسب برای کاهش نفخ و گرفتگی عروق بوده، همچنین قاعده آور و اشتها آور است. برای ناراحتی های کبدی و طحال، برای دیابت بی مزه و برای ناراحتی های روده هم نیز مفید است.",
        },
        {
          name: "عسل سياهدانه",
          benefit:
            "عسل سیاهدانه مقوی مغز و اعصاب بوده و به تقویت حافظه کمک می کند و خواب آور است، باعث ازدیاد شیر مادر و درمان بیماری های کلیوی می شود. بادشکن و قاعده آور است، سردرد و روماتیسم را بهبود می بخشد. همچنین برای ضعف بدن، رفع مسمومیت های خون، کبد، تهوع، شکم درد، یبوست، تقویت زنان زائو، کاهش رطوبت های موجود در بدن، اعتدال بخشیدن به اخلاط بدن، مفید برای دیابت بی مزه، مفید برای انواع قولنج، ناراحتی های تنفسی، روشن کردن رنگ و رو، برای سنگ کلیه، مثانه و سیستم اورولوژی و دردهای رحمی مفید است.",
        },
        {
          name: "عسل زرشک",
          benefit:
            "عسل زرشک از شهد گلهای درخت زرشک به دست می آید، عسل زرشک در ادریبهشت و خرداد تولید شده و از عسل های بهاره به شمار می رود که خاص منطقه خراسان است و به دلیل شرایط اقلیمی و پوشش گیاهی خاص از خواص زیادی برخوردار است. عسل زرشک به رنگ زرد طلایی با عطر مطبوع و طعم شیرین دلچسب می باشد. عسل زرشک باعث تصفیه خون، کاهش فشار خون، درمان مشکلات کبدی و تنظیم قند خون می شود.",
        },
      ],
    };
  },
  mounted() {
    this.benefitOfHoney = 'عسل کنار مقوی و انرژی زا است که به تقویت حافظه و رشد کودکان کمک می کند، مسهل صفرا، حرارت بدن را فرو مینشاند، مؤثر و بازکننده گرفتگی هاست، کرم معده و روده را از بین می برد، مفید برای گرم مزاجان، برای ناراحتی ها و زخم روده و تب نافع است، برای آبله و سرخجه و عطش، همچنین سستی اعضا، تقویت مو، جلوگیری از ریزش مو، تقویت اعصاب و تحلیل ورم های گرم مؤثر و سودمند است.';
  },
  methods: {
    showBenefit(name,e) {
      this.enterBenefitOfHoney = false;
      window.scrollTo({
        behavior:'smooth',
        top:window.innerHeight
      })
      setTimeout(() => {
        let currentHoney = this.benefitHoneyeList.find((honey) => {
          return name === honey.name;
        });
        this.benefitOfHoney = currentHoney.benefit;
        this.enterBenefitOfHoney = true;
      }, 600);
      let element=e.currentTarget
      element.classList.add('active')
      setTimeout(()=>{
        element.classList.remove('active')
      },400)
    },
  },
};
</script>

<style></style>
